const calculatePriceChange = (position, rates) => {
	const { status } = position;
	const { positionPriceDiffPercent, enterPrice } = position?.position_info;

	const { leverage } = position.position_settings;

	const { execution_type } = position?.strategy;
	const { info } = position?.platform;
	const { platformKey } = info;

	const { symbol } = position?.parity;

	const key = `${platformKey}-${symbol}`;

	if (status === "CLOSED") {
		return (positionPriceDiffPercent * (leverage ?? 1)).toFixed(2);
	}

	// status === "OPEN"

	if (!rates?.[key]) {
		console.log(`Rate could not be found: ${key}.`);
		return 0;
	}

	const currentPrice = rates?.[key];

	return (
		(execution_type === "SHORT" ? -1 : 1) *
		((currentPrice - enterPrice) / enterPrice) *
		(leverage ?? 1) *
		100
	).toFixed(2);
};

export { calculatePriceChange };
